"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typesafe_actions_1 = require("typesafe-actions");
exports.submitDrawing = typesafe_actions_1.createAction('@client/submitDrawing')();
exports.submitGuess = typesafe_actions_1.createAction('@client/submitGuess')();
exports.notifyPlayerReady = typesafe_actions_1.createAction('@client/notifyPlayerReady')();
exports.revealChain = typesafe_actions_1.createAction('@client/revealChain')();
exports.startGame = typesafe_actions_1.createAction('@client/startGame')();
exports.joinGame = typesafe_actions_1.createAction('@client/joinGame')();
exports.vote = typesafe_actions_1.createAction('@client/vote')();
